import uiRouter from 'angular-ui-router';
import mainRoutingComponent from './mainRouting.component';
import index from './index/index';
//import maintenance from './maintenance/maintenance';
import { checkRoutes } from './checkRoutes.helper.js';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let mainRoutingModule = angular.module('components.mainRouting', [
  uiRouter,
  index
  //maintenance
])

  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    function redirectToEntryPoint($window, $state, $log, entryPoint) {
      $window.innerWidth < 1024 ? $state.go(entryPoint) : $state.go(STATES.INDEX);
    }

    $urlRouterProvider.when(ROUTES.ROOT, ['$window', '$state', '$log', 'entryPoint', redirectToEntryPoint]);

    $urlRouterProvider.otherwise(checkRoutes);

    $stateProvider
      .state(STATES.MAIN_ROUTING, {
        abstract: true,
        url: ROUTES.ROOT,
        component: 'mainRouting'
      });
  })

  .component('mainRouting', mainRoutingComponent)

  .name;

export default mainRoutingModule;



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/mainRouting.js